<template>
  <v-container class='input-text-size'>
    <CRUDList
      ref="crudList"
      :canAdd="false"
      :canDownload="true"
      :headers='headers'
      :displayTopPagination="false"
      :canEdit="false"
      :canSave="false"
      :showDate="true"
      :showTotal="true"
      :baseCrudKey="baseCrudKey"
      @loadCRUDList="handleLoadCrudList"
      @emitDownloadRowItem="handleDownloadRowItem"
      tableWrapperDynamicClassname='elevation-3 ma-3 pa-3 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      tableDynamicHeight='250'
      :defaultSortBy="sortBy"
      :showSelect="false">
      </CRUDList>
    </v-container>
</template>

<script>
import {
  mapMutations, mapActions, mapState, mapGetters,
} from 'vuex';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import { clients } from '../../../../util/clients';
import { getRawJwt } from '../../../../util/jwt';

const { backendRest } = clients.direct;

export default {
  name: 'archivedReports',
  data() {
    return {
      headers: [
        { text: 'PDF Name', value: 'pdfName' },
      ],
      baseCrudKey: 'archivedReports',
      sortBy: [
        {
          column: 'taxYear',
          direction: 'desc',
        },
      ],
    };
  },
  components: {
    CRUDList,
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'item',
    ]),
    ...mapState({
      wkstNumList: (state) => state.tax.taxPayment.wkstNumList || [],
    }),
  },
  methods: {
    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setCriteria']),
    ...mapActions('tax/taxPstPeriod', [
      'getAllTheNewPostingPeriodPdfNames',
    ]),
    urlEncodeObject(obj) {
      return new URLSearchParams(obj).toString();
    },
    getAuthToken() {
      return getRawJwt();
    },
    async handleLoadCrudList() {
      this.getAllTheNewPostingPeriodPdfNames({
        postProcessTrans: this.postProcessData,
        baseCrudKey: this.baseCrudKey,
      });
    },
    postProcessData(data) {
      const processedData = [];
      const taxrollAudit = data.taxrollSummary || [];
      const taxrollSummary = data.taxrollAudit || [];
      const combinedData = [...taxrollSummary, ...taxrollAudit];
      for (let i = 0; i < (combinedData || []).length; i += 1) {
        const element = combinedData[i];
        processedData.push({ pdfName: element });
      }
      return processedData;
    },
    handleDownloadRowItem(item) {
      const criteria = {
        token: this.getAuthToken(),
        pdfName: item.pdfName,
      };
      const to = `taxInquiry/download-existing-posting-period-pdf?${this.urlEncodeObject(criteria)}`;
      const toUrl = `${backendRest.defaults.baseURL}/${to}`;
      window.open(toUrl);
    },
  },
};
</script>
